import React, {useState} from "react";
import MainContent from "./MainContent/MainContent";
import Faq from "../../GlobalComponents/Faq/Faq";
import NavLayout from "../../GlobalComponents/NavLayout/NavLayout";
import { common, privateNav } from "../../utils/navItems";
import Footer from "../../GlobalComponents/Footer/Footer";
import ConnectButton from "../../GlobalComponents/ConnectButton/ConnectButton";

const Subscription = () => {
  const [address, setAddress] = useState("");
  return (
    <div>
      <NavLayout
        navItems={privateNav}
        setAddress={setAddress}
        buttons={
          <div className="button-container">
            <button className=" w-[120px] h-10 border font-normal text-res-xs leading-[19px] border-solid border-main-green">
              <span>R34P</span>
              <span className="font-black"> $36.65</span>
            </button>
            <ConnectButton text="Connect Wallet"></ConnectButton>
          </div>
        }
      ></NavLayout>
      <div className="mt-[80px] text-center">
        <h2 className="text-res-xl font-bold">Subscription Service</h2>
        <p className="text-res-sm font-medium md:leading-[24px]">
          Maximize Your Profits with Expert Trading Signals
        </p>
      </div>
      <div>
        <MainContent></MainContent>
      </div>
      <div className="mt-[50px] md:mt-[260px]">
        <Faq></Faq>
      </div>
      <div className="mt-10">
        <Footer></Footer>
      </div>
    </div>
  );
};

export default Subscription;
